<template>
  <div class="trial-apply-page">
    <main class="trial-apply">
      <div class="trial-apply-layout">
        <header class="trial-apply-header">
          <p class="trial-eyebrow">DCMP 企业试用</p>
          <h1 id="trial-page-title">让电池数字护照，<br class="trial-title-break">从试用开始。</h1>
          <p class="trial-description">填写企业信息，提交您的试用需求。<br>审核通过后，通过企业邮箱激活账号。</p>
          <ol class="trial-process" aria-label="试用申请流程">
            <li><span class="trial-step" aria-hidden="true">1</span><div><strong>填写申请</strong><p>保留申请编号，便于后续查询</p></div></li>
            <li><span class="trial-step" aria-hidden="true">2</span><div><strong>运营审核</strong><p>我们将核实您的企业试用需求</p></div></li>
            <li><span class="trial-step" aria-hidden="true">3</span><div><strong>邮件激活</strong><p>按审核邮件指引，开启试用</p></div></li>
          </ol>
          <router-link class="trial-back" to="/home"><span aria-hidden="true">←</span> 返回官网首页</router-link>
        </header>
        <form-nav standalone />
      </div>
    </main>
    <footer class="trial-apply-footer">
      <span>{{ $portalText('navigation', 'siteName') }}</span>
      <p>{{ $portalText('footer', 't011') }} <a :href="recordLink" target="_blank" rel="noopener noreferrer">{{ $portalText('footer', 't012') }}</a></p>
    </footer>
  </div>
</template>

<script>
import { safePortalLink } from '@/portal/content.mjs';
export default {
  name: 'TrialApply',
  metaInfo: {
    title: '申请 DCMP 企业试用 | 电池数字护照',
    meta: [{ name: 'description', content: '申请 DCMP 企业试用，填写企业信息和试用需求，审核通过后通过企业邮箱激活，开启电池数字护照体验。' }],
    link: [{ rel: 'canonical', href: 'https://www.chdpp.com/trial/' }],
  },
  computed: { recordLink() { return safePortalLink(this.$portalText('footer', 'l004')); } },
};
</script>

<style scoped>
.trial-apply-page { --trial-accent: #006b80; background: #f5f5f7; color: #1d1d1f; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif; font-size: 16px; line-height: 1.6; }
.trial-apply-page * { box-sizing: border-box; font-family: inherit; font-size: inherit; flex-shrink: 1; }
.trial-apply { padding: clamp(40px, 5vw, 88px) 32px 64px; min-height: calc(100vh - 172px); }
.trial-apply-layout { display: grid; grid-template-columns: minmax(280px, 0.8fr) minmax(0, 1.2fr); align-items: start; gap: clamp(48px, 6vw, 112px); max-width: 1200px; margin: 0 auto; }
.trial-apply-header { padding: 28px 0; min-width: 0; }
.trial-eyebrow { margin: 0 0 20px; color: var(--trial-accent); font-size: 14px; font-weight: 600; letter-spacing: 0.08em; }
.trial-apply-header h1 { margin: 0; color: #1d1d1f; font-size: clamp(34px, 3vw, 44px); font-weight: 600; letter-spacing: -0.025em; line-height: 1.28; }
.trial-description { margin: 24px 0 0; color: #515154; font-size: 17px; line-height: 1.75; }
.trial-process { margin: 44px 0 36px; padding: 0; list-style: none; display: grid; gap: 28px; }
.trial-process li { display: flex; align-items: flex-start; gap: 16px; position: relative; }
.trial-process li:not(:last-child)::after { content: ''; position: absolute; left: 15px; top: 37px; width: 1px; height: 32px; background: #d9e0e4; }
.trial-step { flex: 0 0 32px; display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d6e2e5; border-radius: 50%; background: #fff; color: var(--trial-accent); font-size: 14px; font-weight: 600; }
.trial-process strong { display: block; font-size: 16px; line-height: 1.5; font-weight: 600; }
.trial-process p { margin: 5px 0 0; color: #6e6e73; font-size: 14px; line-height: 1.65; }
.trial-back { display: inline-flex; gap: 8px; align-items: center; color: #56616d; font-size: 14px; line-height: 24px; text-decoration: none; }
.trial-back:hover { color: var(--trial-accent); }
.trial-back:focus-visible, .trial-apply-footer a:focus-visible { outline: 3px solid #78b5c3; outline-offset: 5px; border-radius: 3px; }
.trial-apply-footer { display: flex; justify-content: space-between; gap: 16px 32px; align-items: center; max-width: 1264px; margin: 0 auto; padding: 24px 32px 30px; color: #6e6e73; font-size: 12px; line-height: 1.8; }
.trial-apply-footer p { margin: 0; text-align: right; }
.trial-apply-footer a { color: inherit; text-decoration: none; }
.trial-apply-footer a:hover { color: var(--trial-accent); text-decoration: underline; }
@media (min-width: 1921px) { .trial-apply { padding-top: 88px; } }
@media (max-width: 1000px) {
  .trial-apply { padding: 40px 24px 48px; }
  .trial-apply-layout { max-width: 680px; grid-template-columns: minmax(0, 1fr); gap: 28px; }
  .trial-apply-header { padding: 0 4px; }
  .trial-eyebrow { margin-bottom: 12px; }
  .trial-apply-header h1 { font-size: 36px; }
  .trial-title-break { display: none; }
  .trial-description { margin-top: 16px; font-size: 16px; }
  .trial-process { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; margin: 24px 0 0; }
  .trial-process li { gap: 9px; align-items: center; }
  .trial-process li::after, .trial-process p, .trial-back { display: none; }
  .trial-process strong { font-size: 14px; white-space: nowrap; }
  .trial-step { width: 26px; height: 26px; flex-basis: 26px; font-size: 12px; }
}
@media (max-width: 600px) {
  .trial-apply { padding: 28px 16px 32px; min-height: auto; }
  .trial-apply-layout { gap: 24px; }
  .trial-apply-header { padding: 0 4px; }
  .trial-apply-header h1 { font-size: clamp(27px, 7.5vw, 34px); }
  .trial-title-break { display: initial; }
  .trial-description { font-size: 15px; line-height: 1.8; }
  .trial-description br { display: none; }
  .trial-process { gap: 8px; }
  .trial-process li { gap: 7px; }
  .trial-process strong { font-size: 13px; }
  .trial-step { width: 24px; height: 24px; flex-basis: 24px; }
  .trial-apply-footer { display: block; text-align: center; padding: 16px 24px 24px; }
  .trial-apply-footer p { margin-top: 6px; text-align: center; overflow-wrap: anywhere; }
}
@media (prefers-reduced-motion: reduce) { .trial-apply-page * { scroll-behavior: auto; transition: none; } }
</style>
